import { getSupabase } from "@dwelldrop/supabase";

export type DpaPolicyDefinition = {
  version: string;
  content: string;
};

export const VENUE_SUPABASE_STORAGE_KEY = "venuehub_venue_token";

export const DEFAULT_DPA_POLICY: DpaPolicyDefinition = {
  version: (import.meta.env.VITE_DPA_REQUIRED_VERSION as string | undefined) ?? "1.0",
  content: [
    "DATA PROCESSING AGREEMENT (DPA)",
    "",
    "This Data Processing Agreement (DPA) is entered into between VenueHub Platform (Data Controller)",
    "and the Venue Owner (Data Processor).",
    "",
    "1. PURPOSE",
    "The Venue Owner agrees to process personal data solely for the purposes of providing venue services through the VenueHub platform.",
    "",
    "2. DATA MINIMIZATION",
    "Only necessary personal data (name, contact, transaction history) will be processed.",
    "",
    "3. SECURITY",
    "The Venue Owner will implement appropriate technical and organizational measures to protect personal data.",
    "",
    "4. SUB-PROCESSORS",
    "No sub-processors will be engaged without prior written consent.",
    "",
    "5. DATA SUBJECT RIGHTS",
    "The Venue Owner will assist in fulfilling data subject requests within statutory timeframes under Singapore PDPA 2012.",
    "",
    "6. BREACH NOTIFICATION",
    "The Venue Owner will notify VenueHub within 24 hours of discovering any data breach.",
    "",
    "7. RETENTION",
    "Personal data will not be retained beyond the stated purpose.",
    "",
    "8. TERMINATION",
    "Upon termination, all personal data will be returned or destroyed within 30 days.",
  ].join("\n"),
};

export async function fetchPublishedDpaPolicy(): Promise<DpaPolicyDefinition> {
  const supabase = getSupabase(VENUE_SUPABASE_STORAGE_KEY);
  const { data, error } = await supabase.rpc("get_dpa_policy");
  if (error || !data) return DEFAULT_DPA_POLICY;

  const row = data as { version?: string; content?: string } | null;
  return {
    version: row?.version ?? DEFAULT_DPA_POLICY.version,
    content: row?.content ?? DEFAULT_DPA_POLICY.content,
  };
}
